import { render, staticRenderFns } from "./BrandBackdrop.vue?vue&type=template&id=8bae5e56&scoped=true"
import script from "./BrandBackdrop.vue?vue&type=script&lang=js"
export * from "./BrandBackdrop.vue?vue&type=script&lang=js"
import style0 from "./BrandBackdrop.vue?vue&type=style&index=0&id=8bae5e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bae5e56",
  null
  
)

export default component.exports